import Typography from "@mui/material/Typography";

export const HistorySource = ({ name }: { name: string }) => (
  <Typography
    sx={{ mb: 0.5, fontSize: theme => theme.typography.pxToRem(12), fontWeight: 600, color: "text.secondary" }}
  >
    {name}
  </Typography>
);
